import { RouterProvider } from "@tanstack/react-router";
import { Provider } from "react-redux";
import { Toaster } from "sonner";

import { router } from "@/routes/appRoutes";
import { store } from "@/store";
import { GlobalPollingModal } from "@/components/organism/GlobalPollingModal/GlobalPollingModal";
import { useGlobalPollingModal } from "@/hooks/ui/useGlobalPollingModal";
import DebugPanelContainer from "@/components/organism/DebugPanel/DebugPanelContainer";
import { useDebugPanelHotkey } from "@/hooks/debug/useDebugPanelHotkey";

function AppContent() {
  const { state: pollingState, handlers: pollingHandlers } = useGlobalPollingModal();
  useDebugPanelHotkey();

  return (
    <>
      <Toaster position="top-right" />
      <RouterProvider router={router} />
      <GlobalPollingModal
        isOpen={pollingState.isOpen}
        title={pollingState.title}
        message={pollingState.message}
        details={pollingState.details}
        onClose={pollingHandlers.handleClose}
      />
      <DebugPanelContainer />
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
